import { render, staticRenderFns } from "./GItemInfoHeader.vue?vue&type=template&id=1f8a0fee&scoped=true&"
import script from "./GItemInfoHeader.vue?vue&type=script&lang=ts&"
export * from "./GItemInfoHeader.vue?vue&type=script&lang=ts&"
import style0 from "./GItemInfoHeader.vue?vue&type=style&index=0&id=1f8a0fee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8a0fee",
  null
  
)

export default component.exports